<script> 
	import { onMount } from 'svelte';
	import TBox from './templates/TBox.svelte';
	import { sTema } from '../stores';
	
	let resultadoBusca = [];

	onMount(async () => {
		$sTema = "dia";	

		let { dados } = JSON.parse(localStorage.getItem('AVAL_RESULTADO_CONSULTA_TRABALHOS'));
		resultadoBusca = dados;
	});
</script>

<style>
.container_tabela {
	overflow-x: auto;
}
</style>

<TBox 
	titulo="Resultado da Consulta" 
	subtitulo="Listagem de projetos - limite de 10 registros por consulta"
	largura="12" 
	icone="buscar"
	deslocamento="0">

	<div class="container_tabela">
		<table class="table is-fullwidth is-hoverable">
			<thead>
				<tr>
					<th>Título</th>
					<th>Modalidade</th>
					<th>Data cadastro</th>
					<th>Apresentações SDG (anos)</th>
				</tr>
			</thead>
			<tbody>
				{#each resultadoBusca as valor}
				<tr>
					<td>{ valor.titulo }</td>
					<td>{ valor.modalidade }</td>
					<td>{ valor.data_criacao }</td>
					<td>
                        {#each valor?.apresentacoes as apresentacao}
                        <a href="#/sdg/trabalhos/visualizar/resumo/{apresentacao?.id}/{valor?.codigo}" target="_blank">{apresentacao?.ano} (abrir resumo)</a>
                        <br>
                        {:else}
                        <p>Sem apresentação cadastrada.</p>
                        {/each}
                    </td>
				</tr>
				{/each}
			</tbody>
		</table>
	</div>

	<hr>
	
	<div class="columns">
		<div class="column is-3">
			<p class="control">
				<a href="#/sdg/trabalhos" class="button is-black is-medium is-outlined is-fullwidth">Voltar</a>
			</p>
		</div>
	</div>
</TBox>